<template>
  <div>
    <div class=" color-font-load text-center">
      myGOD Dashboard
      <br>
      Please Use the Search Panels Above to Define Graph Parameters
    </div>
  </div>
</template>

<script>
export default {
  name: "Placeholder"
}
</script>

<style scoped>

.color-font-load {
  color: #aab7bf !important;
  font-size: larger;
}
</style>